import styled from 'styled-components/macro';

import { distances } from '../../../styles/constants';

const Dd = styled.dd`
    padding: 0;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    font-size: 14px;
    line-height: ${distances.normal};
    white-space: nowrap;
`;

export default Dd;
